import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core'
import { ColumnMapType } from 'src/app/_helpers/Table-settings'
import { deepcopy } from 'src/app/_helpers/Utils';

@Component({
	selector: 'table-settings',
	templateUrl: './table-settings.components.html'
})
export class TableSettings implements OnInit, OnDestroy {

  @Input() public columnsSettings: ColumnMapType;
  @Output() public cancelSetting: EventEmitter<void> = new EventEmitter()
  @Output() public confirmSetting: EventEmitter<ColumnMapType> = new EventEmitter()

  public handlerSettings: ColumnMapType;

  public ngOnInit(): void {
    document.body.style.overflow = 'hidden';

    this.handlerSettings = deepcopy(this.columnsSettings);
  }

  public switchVisibility(name: string){
    this.handlerSettings[name].visible = !this.handlerSettings[name].visible;
  }

  public confirm() {
    this.confirmSetting.emit(this.handlerSettings)
  }

  public cancel() {
    this.cancelSetting.emit()
  }

  noOrderCompareFn() {
    return 0;
  }

  public ngOnDestroy(): void {
    document.body.style.overflow = 'auto'
  }
}
